import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CurrentUserState } from '../_reducers/currentUser';

export const selectCurrentUserState = createFeatureSelector<CurrentUserState>('currentUser');

export const selectCurrentUser = createSelector(
  selectCurrentUserState,
  (state: CurrentUserState) => state.user
);

export const selectCurrentUserLoading = createSelector(
  selectCurrentUserState,
  (state: CurrentUserState) => state.loading
);

export const selectCurrentUserError = createSelector(
  selectCurrentUserState,
  (state: CurrentUserState) => state.error
);
